export type ShopsReducerState = {
  activeShopId: string;
};

const ShopsInitialState: ShopsReducerState = {
  activeShopId: '',
};

type ShopsReducerActions = {
  type: 'SET_ACTIVE_SHOP';
  shopId: string;
};

export const ShopsReducer = (
  state: ShopsReducerState = ShopsInitialState,
  action: ShopsReducerActions,
) => {
  if (action.type === 'SET_ACTIVE_SHOP') {
    return {
      activeShopId: action.shopId,
    };
  }
  return state;
};

export const setActiveShop = (shopId: string) => ({
  type: 'SET_ACTIVE_SHOP',
  shopId,
});
